module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      picker: true, active: _vm.active
    }
  }, [(_vm.showList && _vm.active) ? _c('div', {
    staticClass: "full-height pickerListContainer"
  }, [(_vm.type == 'pictureWalls') ? _c('picture-wall-list', {
    attrs: {
      "list-data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'backgrounds') ? _c('background-list', {
    attrs: {
      "list-data": _vm.data
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1788ca98!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Picker/Picker.vue
// module id = 147
// module chunks = 0